<div class="chart-section">
    <div class="chart-header">
        <h3>{{ 'reportingV2.ASSIGNMENT_PROGRESS' | transloco }}</h3>
        <div class="status-container">
            <span class="status">
                <span class="dot assigned"></span> {{ 'reportingV2.ASSIGNED_LABEL' | transloco }}
            </span>
            <span class="status">
                <span class="dot in-progress"></span> {{ 'reportingV2.IN_PROGRESS_LABEL' | transloco }}
            </span>
            <span class="status">
                <span class="dot certified"></span> {{ 'reportingV2.CERTIFIED_LABEL' | transloco }}
            </span>
            <span class="status">
                <span class="dot out-of-attempts"></span> {{ 'reportingV2.OUT_OF_ATTEMPTS_LABEL' | transloco }}
            </span>
        </div>
    </div>
    <div #chartContainer class="chart-container"></div>

    <div class="chart-title-fixed">
        {{ 'reportingV2.ASSIGNMENT_NAME' | transloco }}
    </div>
</div>